import { Table, Badge, Button } from "react-bootstrap";
import { FaEdit, FaRedo, FaTrash } from "react-icons/fa";
import classes from "./UsersTable.module.css";

export default function UsersTable({ users }) {

    const badgeColor = (status) => {
        if (status === 1) return "success";
        if (status === 0) return "danger";
        return "secondary";
    };

    return (
        <div className="table-responsive">
            <Table bordered className={classes.customTable}>
                <thead className="table-dark">
                    <tr>
                        <th>ID</th>
                        <th>Usuário</th>
                        <th>Tipo</th>
                        <th>Status</th>
                        <th>Criado em</th>
                        <th className="text-center">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map((l, index) => {
                        const rowStyle = index % 2 === 0 ? classes.rowEven : classes.rowOdd;

                        return (
                            <tr key={l.id} className={rowStyle}>
                                <td>{l.id}</td>
                                <td>{l.nome}</td>

                                <td>{l.type}</td>

                                <td>
                                    <Badge bg={badgeColor(l.active)}>
                                        {l.active ? 'Ativo' : 'Inativa'}
                                    </Badge>
                                </td>

                                <td className="text-nowrap">{l.created}</td>

                                <td>
                                    <div className="d-flex justify-content-center">
                                        <Button size="sm" variant="outline-primary" className="me-1 mr-1" title="Editar">
                                            <FaEdit />
                                        </Button>
                                        <Button size="sm" variant="outline-danger" title="Excluir">
                                            <FaTrash />
                                        </Button>
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </div>
    );
}